module.exports = __webpack_public_path__ + "static/media/search-close.ea67360b.svg";